'use strict';

var FlightDateRangeFilterFactory = function FlightDateRangeFilterFactory(DataRangeFilter) {
  function FlightDateRangeFilter() {
    DataRangeFilter.call(this, ['cabin', 'cabin-da', 'class', 'cabin-post-departure', 'class-post-departure'], 'dateRange', 1);
  }
  FlightDateRangeFilter.prototype = Object.create(DataRangeFilter.prototype);
  FlightDateRangeFilter.prototype.groupBy = 'flightDepartureDateMoment';
  FlightDateRangeFilter.prototype.filterGroup = function (dateRange) {
    return function (departureDate) {
      for (var i = 0, len = dateRange.length; i < len; i++) {
        var val = dateRange[i];
        if (!departureDate.isBefore(val.from, 'day') && !departureDate.isAfter(val.to, 'day')) {
          return true;
        }
      }
    };
  };
  return FlightDateRangeFilter;
};
FlightDateRangeFilterFactory.$inject = ['DataRangeFilterFactory'];
module.exports = FlightDateRangeFilterFactory;